import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PassValidationService } from 'src/app/validators/pass-validation.service';
import { StoreResponseDto, StoreService, StoreNewPswDto } from 'src/generated_client';
import { AuthService } from 'src/app/services/auth/auth.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-shop-password',
  templateUrl: './shop-password.component.html',
  styleUrls: ['./shop-password.component.css']
})

export class ShopPasswordComponent implements OnInit {

  CurrentStore: StoreResponseDto = {} as StoreResponseDto;
  PassUpdate: StoreNewPswDto = {} as StoreNewPswDto;

  passwordForm: FormGroup = this.fb.group({

    dsPassword: ['', Validators.required],
    dsNewPassword: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, Validators.minLength(8)])],
    confirmNew: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])]
  },
    {
      validator: this.validador.passValidator(
        "dsNewPassword",
        "confirmNew"
      )
    }
  )

  constructor(
    private fb: FormBuilder,
    private validador: PassValidationService,
    private storeService: StoreService,
    private authService: AuthService,
    private snackBar: SnackBarService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.CurrentStore = this.authService.currentUserStore();
  }

  saveChanges(form: any) {

    if (this.passwordForm.valid) {

      this.PassUpdate = {
        dsEmail: String(this.CurrentStore.dsEmail),
        dsPassword: form.dsPassword,
        dsNewPassword: form.dsNewPassword
      }

      this.storeService.apiStoreChangePswPut(this.PassUpdate).subscribe(() => {

        this.snackBar.openSnackBar("Contraseña cambiada exitosamente", "Aceptar");
        this.router.navigate(['shop-home']);
      },
        err => {

          this.snackBar.openSnackBar(err.error.error, 'Aceptar');
          this.ResetControls();
        }
      )
    }
  }

  private ResetControls() {
    this.passwordForm.controls['dsPassword'].reset();
    this.passwordForm.controls['dsNewPassword'].reset();
    this.passwordForm.controls['confirmNew'].reset();
  }
}
